webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
__webpack_require__("wPPq");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "1qJd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInstance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var axios = __webpack_require__("mtWM");

function createInstance(authService, cacheConfig, cachios) {
  var axiosInstance = axios.create({});

  axiosInstance.interceptors.request.use(function (config) {
    config.headers['Authorization'] = authService.getAuthToken();
    return config;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });

  axiosInstance.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      authService.logOut();
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });

  return cachios.create(axiosInstance, cacheConfig);
}


/***/ }),

/***/ "4sUD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.svg";

/***/ }),

/***/ "5SNe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-eot.eot";

/***/ }),

/***/ "85ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    label: {
      default: 'Loading...'
    },
    show: {
      default: false
    },
    overlay: {
      default: true
    },

    eventBus: {
      default: null
    },
    eventShow: {
      default: 'show-full-loading'
    },
    eventHide: {
      default: 'hide-full-loading'
    }
  },
  data: function data() {
    return {
      showing: false
    };
  },

  watch: {
    show: function show(val) {
      this.showing = val;
    }
  },
  methods: {
    showMe: function showMe() {
      this.showing = true;
    },
    hideMe: function hideMe() {
      this.showing = false;
    },
    registerBusMethods: function registerBusMethods() {
      this.eventBus.$on(this.eventShow, this.showMe);
      this.eventBus.$on(this.eventHide, this.hideMe);
    }
  },
  mounted: function mounted() {
    if (this.eventBus) {
      this.registerBusMethods();
    }
  }
});

/***/ }),

/***/ "A8LY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B+/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureRouter;
function configureRouter(router) {}

/***/ }),

/***/ "HgM1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/login-image.jpg";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ca1ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kuXo");
function injectStyle (ssrContext) {
  __webpack_require__("lDMU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19ca1ade_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N8fj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_configuration_PropertiesConfiguration__ = __webpack_require__("d45q");




var Cookies = __webpack_require__("lbHh");

var LoginService = function () {
  function LoginService(axios) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LoginService);

    this.axios = axios;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LoginService, [{
    key: 'login',
    value: function login(credentials) {
      return this.axios.post(__WEBPACK_IMPORTED_MODULE_2__services_configuration_PropertiesConfiguration__["a" /* default */].loginEndPoint, credentials);
    }
  }, {
    key: 'setAuthToken',
    value: function setAuthToken(token, username) {
      var inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);
      Cookies.set('securityToken', token, { expires: inTwentyMinutes });
      Cookies.set('loggedInUserName', username, { expires: inTwentyMinutes });
    }
  }, {
    key: 'saveUsername',
    value: function saveUsername(username) {
      var inTwentyMinutes = new Date(new Date().getTime() + 20 * 60 * 1000);
      Cookies.set('username', username, { expires: inTwentyMinutes });
    }
  }, {
    key: 'getSavedUsername',
    value: function getSavedUsername() {
      return Cookies.get('username');
    }
  }, {
    key: 'getLoggedInUserName',
    value: function getLoggedInUserName() {
      return Cookies.get('loggedInUserName');
    }
  }, {
    key: 'logout',
    value: function logout() {
      Cookies.remove('securityToken');
      Cookies.remove('loggedInUserName');
    }
  }]);

  return LoginService;
}();

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_routerConfig__ = __webpack_require__("B+/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LoginService__ = __webpack_require__("N8fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_validation_messages__ = __webpack_require__("lIB4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_toasted__);












__webpack_require__("85ql");

var config = {
  locale: 'en',
  dictionary: __WEBPACK_IMPORTED_MODULE_8__assets_validation_messages__["a" /* default */],
  events: 'input'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */], config);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_toasted___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  provide: { loginService: new __WEBPACK_IMPORTED_MODULE_5__services_LoginService__["a" /* LoginService */]() }
});
Object(__WEBPACK_IMPORTED_MODULE_4__router_routerConfig__["a" /* configureRouter */])(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

/***/ }),

/***/ "NtoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__ = __webpack_require__("tpCU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__ = __webpack_require__("d45q");







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['redirect_uri'],
  name: 'login',
  components: {
    'loading': __WEBPACK_IMPORTED_MODULE_1__components_Loading_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showSpinner: false,
      loginInfo: {
        usrname: '',
        passwrd: ''
      },
      redirectURI: '',
      rememberMe: false,
      errorCode: '',
      errorMessage: '',
      loginErrorMessage: '',
      forgotCredentialsUrl: '',
      registrationUrl: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.redirectURI = vm.$route.query.redirect_uri;
      if (__WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__["a" /* authService */].isLoggedIn()) {
        var redirectURL = vm.redirectURI;
        if (redirectURL !== undefined) {
          window.location.href = redirectURL;
        } else {
          window.location.href = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].defaultURI;
        }
      } else {}
    });
  },
  mounted: function mounted() {
    this.loginInfo.usrname = __WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__["b" /* loginService */].getSavedUsername();
    this.forgotCredentialsUrl = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].forgotCredentialsUrl;
    this.registrationUrl = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].registrationUrl;
    this.redirectURI = this.redirect_uri;
  },

  methods: {
    togglePassword: function togglePassword() {
      var newType = this.$refs['loginPasswrd'].getAttribute('type') === 'password' ? 'text' : 'password';
      this.$refs['loginPasswrd'].setAttribute('type', newType);
      this.$refs['loginPasswrd'].focus();
    },
    validateAndSubmitForm: function validateAndSubmitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.performLogin();
          return;
        }
      });
    },
    performLogin: function performLogin() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.showSpinner = true;
        __WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__["b" /* loginService */].login({
          username: _this2.loginInfo.usrname,
          password: _this2.loginInfo.passwrd
        }).then(function (response) {
          _this2.showSpinner = false;
          _this2.setData(response.data);

          if (_this2.loginInfo.rememberMe) {
            _this2.saveUsername(_this2.loginInfo.usrname);
          }

          if (_this2.redirectURI !== undefined) {
            window.location.href = _this2.redirectURI;
          } else {
            window.location.href = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].defaultURI;
          }
          resolve(response);
        }).catch(function (error) {
          _this2.showSpinner = false;
          if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
            _this2.loginErrorMessage = error.response.data.errorMessage;
          } else {
            _this2.loginErrorMessage = 'There was an unexpected error when trying to login.';
          }
          reject(error);
        });
      });
    },
    setData: function setData(response) {
      __WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__["b" /* loginService */].setAuthToken(response.securityToken, this.loginInfo.usrname);
      this.errorCode = response.errorCode;
    },
    saveUsername: function saveUsername(username) {
      __WEBPACK_IMPORTED_MODULE_2__services_ServiceContainer__["b" /* loginService */].saveUsername(username);
    },
    redirectToForgotCredentials: function redirectToForgotCredentials() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].forgotCredentialsUrl;
    },
    redirectToRegistration: function redirectToRegistration() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_3__services_configuration_PropertiesConfiguration__["a" /* default */].registrationUrl;
    }
  }
});

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad9dbb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("RsM9");
function injectStyle (ssrContext) {
  __webpack_require__("A8LY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ad9dbb3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ad9dbb3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RqFH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff2.woff2";

/***/ }),

/***/ "RsM9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showing)?_c('div',{class:{'white-overlay': _vm.overlay}},[_c('div',{attrs:{"id":"loader24"}}),_vm._v(" "),_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"pulled-left",staticStyle:{"padding":"10px 20px"}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-layer spinner-layer--blue"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--red"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--yellow"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--green"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Login__ = __webpack_require__("lmfZ");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '*',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Login__["a" /* default */],
    props: function props(route) {
      return {
        redirect_uri: route.query.redirect_uri
      };
    }
  }]
}));

/***/ }),

/***/ "ZORx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d45q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);



var Config = function Config() {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Config);

  var envPath = __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForWebEnvironment();
  if (envPath === '') {
    envPath = 'www';
  }

  this.loginEndPoint = 'https://webservice' + __WEBPACK_IMPORTED_MODULE_1_my_account_common__["PathSolver"].getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-login-process/login';

  this.defaultURI = 'https://' + envPath + '.24hourfitness.com/myaccount/profile.html';

  this.forgotCredentialsUrl = 'https://' + envPath + '.24hourfitness.com/forgotCredentials.html';
  this.registrationUrl = 'https://' + envPath + '.24hourfitness.com/registration.html';
};

var cfg = new Config();
/* harmony default export */ __webpack_exports__["a"] = (cfg);

/***/ }),

/***/ "kuXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('title-container',{attrs:{"title":'My24 Account'}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lDMU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lIB4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dictionary = {
  en: {
    messages: {
      required: function required() {
        return 'This is a required field.';
      }
    },
    custom: {}
  }
};

/* harmony default export */ __webpack_exports__["a"] = (dictionary);

/***/ }),

/***/ "lmfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NtoT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb7c44b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("w2XB");
function injectStyle (ssrContext) {
  __webpack_require__("ZORx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb7c44b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sPdF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-woff.woff";

/***/ }),

/***/ "tpCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export axios */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authService; });
/* unused harmony export sessionCache */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loginService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginService__ = __webpack_require__("N8fj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios_axiosConfigurer__ = __webpack_require__("1qJd");




var authService = new __WEBPACK_IMPORTED_MODULE_1_my_account_common__["AuthService"]();
var sessionCache = new __WEBPACK_IMPORTED_MODULE_1_my_account_common__["SessionCache"](authService, { key: 'my-login' });
var axiosCache = Object(__WEBPACK_IMPORTED_MODULE_2__axios_axiosConfigurer__["a" /* cachiosConfigure */])(authService, { ttl: 5, sessionCache: sessionCache }, __WEBPACK_IMPORTED_MODULE_1_my_account_common__["cachiosFactory"]);
var loginService = new __WEBPACK_IMPORTED_MODULE_0__LoginService__["a" /* LoginService */](axiosCache);


/***/ }),

/***/ "uk6X":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular-ttf.ttf";

/***/ }),

/***/ "w2XB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"login"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":true}}),_vm._v(" "),_c('div',{staticClass:"container login-container"},[_vm._m(0,false,false),_vm._v(" "),(_vm.loginErrorMessage.length > 0)?_c('div',{staticClass:"row error-message-section"},[_c('section',{staticClass:"col-sm-12 alert alert-danger",attrs:{"role":"alert"}},[_c('div',[_c('a',{staticClass:"close marright10",attrs:{"aria-label":"close","title":"close"},on:{"click":function($event){_vm.loginErrorMessage = ''}}},[_vm._v("\n            ×\n          ")]),_vm._v(" "),_c('span',{staticClass:"marleft10"},[_vm._v(_vm._s(_vm.loginErrorMessage))])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"container login-container"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.validateAndSubmitForm($event)}}},[_c('div',{staticClass:"row login-section login-end-page"},[_c('section',{staticClass:"card-24 col-md-12 login-info-section"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('div',{staticClass:"materialized form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.usrname),expression:"loginInfo.usrname"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control form-control-warning",class:{'input': true, 'is-danger': _vm.errors.has('login-info-usrname')},attrs:{"type":"text","id":"login-info-usrname","name":"login-info-usrname","placeholder":"Username or Check-In Code"},domProps:{"value":(_vm.loginInfo.usrname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "usrname", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"login-info-usrname"}},[_vm._v("Username or Check-In Code")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('login-info-usrname')),expression:"errors.has('login-info-usrname')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('login-info-usrname')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('div',{staticClass:"form-group materialized"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginInfo.passwrd),expression:"loginInfo.passwrd"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"loginPasswrd",staticClass:"form-control form-control-warning",class:{'input': true, 'is-danger': _vm.errors.has('loginPasswrd')},attrs:{"type":"password","id":"login-info-passwrd","name":"loginPasswrd","placeholder":"Password"},domProps:{"value":(_vm.loginInfo.passwrd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginInfo, "passwrd", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"login-info-passwrd"}},[_vm._v("Password")]),_vm._v(" "),_c('span',{staticClass:"input-group-btn btn btn-view pull-right"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":function($event){_vm.togglePassword()}}},[_c('i',{ref:"eyeIcon",staticClass:"fa fa-eye",attrs:{"aria-hidden":"true"}})])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('loginPasswrd')),expression:"errors.has('loginPasswrd')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('loginPasswrd')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"materialized col-xs-6"},[_c('div',{staticClass:"materialized form-group"},[_c('el-checkbox',{attrs:{"role":"button","id":"remember_me","label":"Remember Me"},model:{value:(_vm.loginInfo.rememberMe),callback:function ($$v) {_vm.$set(_vm.loginInfo, "rememberMe", $$v)},expression:"loginInfo.rememberMe"}})],1)]),_vm._v(" "),_c('div',{staticClass:"materialized col-xs-6"},[_c('div',{staticClass:"forgot-password-link form-group"},[_c('a',{attrs:{"href":_vm.forgotCredentialsUrl},on:{"click":function($event){_vm.redirectToForgotCredentials()}}},[_vm._m(2,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"row martop20"},[_c('div',{staticClass:"materialized col-xs-12"},[_c('div',{staticClass:"create-account-link form-group"},[_c('a',{attrs:{"href":_vm.registrationUrl},on:{"click":function($event){_vm.redirectToRegistration()}}},[_vm._m(3,false,false)])]),_vm._v(" "),_vm._m(4,false,false)])])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row login-section"},[_c('section',{staticClass:"col-sm-12 login-desc-header"},[_c('h1',{staticClass:"title-24"},[_vm._v("Sign In")]),_vm._v(" "),_c('div',{staticClass:"card-text-container col-sm-12 login-desc-text"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("\n                Manage your membership online. Edit your profile, make payments, see your club visits and Fit:Perks® rewards,\n                and add services like personal training.\n              ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-img-container left-side col-md-6"},[_c('img',{staticClass:"full-img",attrs:{"src":__webpack_require__("HgM1"),"alt":"Member Sign In"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"labelPointer"},[_c('u',[_vm._v("I forgot my username/password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"labelPointer"},[_c('u',[_vm._v("Create New Account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-primary btn-block pull-right",attrs:{"id":"login-btn","type":"submit"}},[_vm._v("Login")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TitleContainer: __WEBPACK_IMPORTED_MODULE_0_my_account_common_vue__["TitleContainer"]
  },
  name: 'app'
});

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.js